function etxScrollyTelling() {

  const modules = document.querySelectorAll('[data-module="ScrollytellingVision"]');
  if (!modules.length) return;

  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  gsap.registerPlugin(ScrollTrigger);

  /* ------------------------------
  LENIS + SCROLLTRIGGER SYNC
  ------------------------------ */

  if (window.lenis && !window.__lenisScrollTriggerBound) {

    window.lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
      window.lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

    window.__lenisScrollTriggerBound = true;
  }

  /* ------------------------------
  INIT EACH MODULE
  ------------------------------ */

  modules.forEach(module => {

    const imageCount = parseInt(module.dataset.imageCount) || 1;
    const isSequence = imageCount > 1;

    const scrollConfig = {
      trigger: module,
      start: "top top",
      end: "+=125%"
    };

    /* ------------------------------
    PIN
    ------------------------------ */

    ScrollTrigger.create({
      ...scrollConfig,
      pin: true
    });

    /* ------------------------------
    IMAGE SEQUENCE
    ------------------------------ */

    if (isSequence) {

      const canvas = module.querySelector('canvas');
      if (!canvas) return;

      const filePath = module.dataset.filePath;
      const fileName = module.dataset.fileName;
      const fileType = module.dataset.fileType;

      const context = canvas.getContext('2d');
      const images = [];
      const sequence = { frame: 0 };

      function setCanvasSize() {
        const rect = canvas.parentElement.getBoundingClientRect();
        canvas.width = rect.width;
        canvas.height = rect.width * 2;
      }

      setCanvasSize();

      for (let i = 0; i < imageCount; i++) {
        const img = new Image();
        img.src = `${filePath}/${fileName}_${i + 1}.${fileType}`;
        images.push(img);
      }

      function scaleImage(img, ctx) {
        var canvas = ctx.canvas;
        var hRatio = canvas.width / img.width;
        var vRatio = canvas.height / img.height;
        var ratio = Math.max(hRatio, vRatio);
        var centerShift_x = (canvas.width - img.width * ratio) / 2;
        var centerShift_y = (canvas.height - img.height * ratio) / 2;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(
          img,
          0, 0, img.width, img.height,
          centerShift_x, centerShift_y,
          img.width * ratio, img.height * ratio
        );
      }

      function render() {
        scaleImage(images[sequence.frame], context);
      }

      images[0].onload = render;

      window.addEventListener("resize", () => {
        setCanvasSize();
        render();
      });

      gsap.to(sequence, {
        frame: imageCount - 1,
        snap: "frame",
        ease: "none",
        scrollTrigger: {
          ...scrollConfig,
          scrub: true
        },
        onUpdate: render
      });

    }

    /* ------------------------------
    SVG PATH DRAW
    ------------------------------ */

    const svgPath = module.querySelector('.Vision__stripe svg path');

    if (svgPath) {
      const pathLength = svgPath.getTotalLength();

      svgPath.style.strokeDasharray = pathLength;
      svgPath.style.strokeDashoffset = pathLength;

      gsap.to(svgPath, {
        strokeDashoffset: 0,
        ease: "none",
        scrollTrigger: {
          ...scrollConfig,
          scrub: true
        }
      });
    }

    /* ------------------------------
    TEXT ANIMATION
    ------------------------------ */

    const text1 = module.querySelector('.ScrollytellingVision__text_1');
    const text2 = module.querySelector('.ScrollytellingVision__text_2');

    if (text1 && text2) {

      const textTl = gsap.timeline({
        scrollTrigger: {
          ...scrollConfig,
          scrub: 0.05
        }
      });

      textTl.fromTo(text1,
        { xPercent: -300 },
        { xPercent: 0, duration: 0.15, ease: "power2.out" },
        0
      );

      textTl.fromTo(text2,
        { xPercent: 300 },
        { xPercent: 0, duration: 0.15, ease: "power2.out" },
        0
      );
    }

  });

}
